module.exports = __webpack_public_path__ + "static/img/SUP.c05a474.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/SUP.png
// module id = Z2b5
// module chunks = 1